import {
	BrowserRouter as Router
} from 'react-router-dom';

import { ScrollTop } from '@arte/asg/lib/react/components';

import { Provider } from '@artegeie/mrc/provider';
import { I18nProvider, ConfigProvider } from '@artegeie/design-system/corporate';

import Content from './Components/Content';
import Footer from './Components/Layout/Footer';
import Header from './Components/Layout/Header';

import getLang from './Utils/getLang';

import useDateLang from './Hooks/useDateLang';

import './scss/site.scss';

const dateLang = useDateLang();
const lang = getLang();

const { sso } = appConfig;

const App = () => {

	const { basePath } = window.appConfig;
	const theme = 'next';

	return (
		<div className={ `theme-${theme}` }>
			<Router basename={ basePath }>
				<Provider locale={lang} client={sso.client} env={sso.env} apiToken={sso.key}>
					<ConfigProvider cdnUrl="" >
						<I18nProvider locale={lang} dateLocale={ dateLang } formaters="" labels="" >
							<Header />
							<Content />
							<Footer />
							<ScrollTop />
						</I18nProvider>
					</ConfigProvider>
				</Provider>
			</Router>
		</div>
	);
};

export default App;
